import Checkbox from '@creditflowresearch/uilib/Checkbox';
import FilterItem from '@/creditflowresearch/ui/common/components/FilterItem';
import FilterSection from '@/creditflowresearch/ui/common/components/templates/FilterSection';
import FilterSectionHeader from '@/creditflowresearch/ui/common/components/organisms/FilterSectionHeader';
import { FilterSectionIds } from '@/creditflowresearch/ui/components/corporate-bond-screener/Sidebar/Sections/constants';
import useEsgSection from './useEsgSection';

const Esg = () => {
  const { items, selectedValues, isAllSelected, isIndeterminate, toggle, toggleAll } = useEsgSection();

  return (
    <FilterSection
      sectionId={ FilterSectionIds.Esg }
      header={ (
        <FilterSectionHeader
          title="ESG"
          leftSlot={ (
            <Checkbox
              checked={ isAllSelected }
              onChange={ toggleAll }
              indeterminate={ isIndeterminate }
              supportIndeterminate
              dataTest="esgFiltersAllCheckbox"
            />
          ) }
        />
      ) }
    >
      { items.map((item) => (
        <FilterItem key={ item.value } isExpandable={ false }>
          <Checkbox
            label={ item.name }
            checked={ selectedValues.includes(item.value) }
            onChange={ () => toggle(item.value) }
            dataTest={ `checkbox-esg-${ item.value }` }
          />
        </FilterItem>
        )) }
    </FilterSection>
  );
};

export default Esg;
